// import logo from './logo.svg';
import React from "react";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import "./App.scss";

function App() {
	return (
		<main>
			<Navbar />
			<About />
			<Projects />
			<Contact />
		</main>
	);
}

export default App;
